/* Package contents - one-row fit + expand/collapse
 *
 * Collapsed: shows as many chips as fit on the FIRST row together with the
 * "+N articole" chip (optionally capped by data-pkg-max). If every chip fits
 * on one row, no toggle is shown at all.
 * Expanded: all chips are shown and the toggle becomes "Mai puțin".
 *
 * The snippet is rendered twice (desktop + mobile copy); the copy that is
 * display:none has zero width and is skipped until it becomes visible, which
 * the ResizeObserver picks up.
 */
(function () {
  function countLabel(n, one, many) {
    var m = n % 100;
    if (n === 1) return '+1 ' + one;
    if (m === 0 || m >= 20) return '+' + n + ' de ' + many;
    return '+' + n + ' ' + many;
  }

  function layout(root) {
    var list = root.querySelector('[data-pkg-list]');
    var more = root.querySelector('[data-pkg-more]');
    var btn = root.querySelector('[data-pkg-toggle]');
    if (!list || !more || !btn) return;
    if (list.clientWidth === 0) return;

    var items = Array.prototype.slice.call(list.querySelectorAll('[data-pkg-item]'));
    if (!items.length) return;

    var max = parseInt(root.getAttribute('data-pkg-max') || '0', 10) || 0;
    var one = btn.getAttribute('data-noun-one') || 'articol';
    var many = btn.getAttribute('data-noun-many') || 'articole';
    var less = btn.getAttribute('data-label-less') || 'Mai puțin';
    var open = root.classList.contains('pkg--open');

    items.forEach(function (el) { el.hidden = false; });
    more.hidden = true;

    var top = items[0].offsetTop;
    var lastTop = items[items.length - 1].offsetTop;
    var fitsAll = lastTop === top && (!max || items.length <= max);

    if (fitsAll) {
      root.classList.remove('pkg--open', 'pkg--collapsible');
      btn.setAttribute('aria-expanded', 'false');
      return;
    }

    root.classList.add('pkg--collapsible');
    more.hidden = false;

    if (open) {
      btn.textContent = less;
      btn.setAttribute('aria-expanded', 'true');
      return;
    }

    var shown = max ? Math.min(max, items.length - 1) : items.length - 1;
    for (var i = shown; i < items.length; i++) items[i].hidden = true;
    btn.textContent = countLabel(items.length - shown, one, many);

    while (shown > 1 && more.offsetTop > top) {
      shown--;
      items[shown].hidden = true;
      btn.textContent = countLabel(items.length - shown, one, many);
    }

    btn.setAttribute('aria-expanded', 'false');
  }

  function initToggle(root) {
    var btn = root.querySelector('[data-pkg-toggle]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var opening = !root.classList.contains('pkg--open');
      root.classList.toggle('pkg--open', opening);
      layout(root);

      if (!opening) {
        var top = root.getBoundingClientRect().top;
        if (top < 0) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  function observe(root) {
    var lastWidth = -1;
    var frame = null;

    function schedule() {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = null;
        var w = root.clientWidth;
        if (w === lastWidth) return;
        lastWidth = w;
        layout(root);
      });
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(schedule).observe(root);
    } else {
      window.addEventListener('resize', function () {
        lastWidth = -1;
        schedule();
      });
    }
    schedule();
  }

  function init() {
    document.querySelectorAll('[data-pkg]').forEach(function (root) {
      if (root.dataset.pkgReady) return;
      root.dataset.pkgReady = '1';
      initToggle(root);
      observe(root);
    });
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      document.querySelectorAll('[data-pkg]').forEach(layout);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
